import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { MapTo } from "@adobe/aem-react-editable-components";
import { Faq as ExternalFaq } from "@jti/ui";
import { withEditConfig } from "../../app-related/withAemAuthoring";
const FaqEditConfig = {
    emptyLabel: "Faq",
    isEmpty: (props) => !props.title ||
        !props.details ||
        !props.detailsLink ||
        !props.additionalHelp ||
        !props.additionalHelpEmail ||
        !props.faqList.length,
};
export const Faq = memo((props) => {
    if (FaqEditConfig.isEmpty(props))
        return null;
    return _jsx(ExternalFaq, { ...props });
});
export default MapTo("loyalty/components/faq")(withEditConfig(Faq, FaqEditConfig));
